import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import ArtistForm from './ArtistForm';

const mapDispatchToProps = dispatch => ({
  onArtistOpen: () => dispatch({type: 'ADMIN_ARTIST_OPEN'}),
  onArtistCancel: () => dispatch({type: 'ADMIN_ARTIST_CANCEL'})
});

const mapStateToProps = state => ({
  ...state.admin
});

class ArtistRow extends Component  {

  constructor(props) {
    super(props);

    this.state = {
      artistForm: "",
    }

  }

  handleClick = (event) => {
    if(this.state.artistForm === "") {
      this.setState({artistForm: <ArtistForm artist={this.props.artist} mediums={this.props.mediums} cancelHandler={this.handleClose} />});
    } else {
      this.setState({artistForm: ""});
    }
  }

  handleClose = event => {
    this.setState({artistForm: ""});
  }

  render() {
    return (
      <div>
        <div onClick={this.handleClick}>
        {this.props.artist.name}
        </div>
        {this.state.artistForm}
      </div>
    );
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(ArtistRow);



// WEBPACK FOOTER //
// ./src/components/Admin/ArtistRow.js